module.exports = {"530181001":"连然街道","530181002":"金方街道","530181003":"八街街道","530181004":"温泉街道","530181005":"青龙街道","530181006":"禄脿街道","530181007":"草铺街道","530181008":"太平新城街道","530181009":"县街街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530181.json
// module id = 2363
// module chunks = 0